import { render, staticRenderFns } from "./ThresholdSlider.vue?vue&type=template&id=966a92ce&scoped=true"
import script from "./ThresholdSlider.vue?vue&type=script&lang=ts"
export * from "./ThresholdSlider.vue?vue&type=script&lang=ts"
import style0 from "./ThresholdSlider.vue?vue&type=style&index=0&id=966a92ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966a92ce",
  null
  
)

export default component.exports